"use client";
import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";

export function useReturnUrl() {
  const [returnUrl, setReturnUrl] = useState("/");
  const searchParams = useSearchParams();

  useEffect(() => {
    const urlParam = searchParams.get("returnUrl");
    const cookieReturnUrl = document.cookie
      .split(";")
      .map((c) => c.trim())
      .find((cookie) => cookie.startsWith("returnUrl="))
      ?.split("=")[1];

    const finalUrl = cookieReturnUrl
      ? decodeURIComponent(cookieReturnUrl)
      : urlParam || "/";

    setReturnUrl(finalUrl);
  }, [searchParams]);

  return returnUrl;
}

export function useNextAuthReturnUrl() {
  const [nextAuthReturnUrl, setNextAuthReturnUrl] = useState<string | null>(
    null
  );

  useEffect(() => {
    const cookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("NextAuthReturnUrl="));

    const value = cookie?.split("=")[1];
    setNextAuthReturnUrl(value ? decodeURIComponent(value) : null);
  }, []);

  return nextAuthReturnUrl;
}
